<template>
  <WCModal @dismiss="dismiss('Dismissed')">
    <WCModalHeader class="align-items-baseline">
      <h1 class="font-size-lg">{{ $t('eGiftCardPolicyHeading') }}</h1>
      <button class="btn btn-link underline-link-from-center" @click="dismiss('Dismissed')">
        {{ $t('close') }}
      </button>
    </WCModalHeader>
    <WCModalBody>
      <div class="d-flex align-items-baseline justify-content-between">
        <WCCustomContent :content="policy" />
      </div>
    </WCModalBody>
  </WCModal>
</template>
<script>
import WCModal from '@/modules/modals/components/WCModal/WCModal.vue';
import WCModalHeader from '@/modules/modals/components/WCModalHeader/WCModalHeader.vue';
import WCModalBody from '@/modules/modals/components/WCModalBody/WCModalBody.vue';
import ModalMixin from '@/modules/modals/mixins/ModalMixin';
import WCCustomContent from '@/components/WCCustomContent/WCCustomContent.vue';

export default {
  name: 'WCGiftCardPolicyModal',
  mixins: [ModalMixin],
  components: { WCModal, WCModalHeader, WCModalBody, WCCustomContent },
  props: {
    policy: { type: String },
  },
};
</script>
